import {
	colorChartsStatusNeutral,
	colorChartsStatusInfo,
	colorChartsStatusMedium,
	colorChartsStatusPositive,
	colorChartsPaletteCategorical1,
	colorChartsPaletteCategorical2,
	colorChartsPaletteCategorical6,
	colorChartsPaletteCategorical7,
	colorChartsPaletteCategorical8,
	colorChartsPaletteCategorical9,
} from '@amzn/awsui-design-tokens';

import { BoardProps } from '@amzn/awsui-board-components-console/board';

export const boardItemI18nStrings = {
	dragHandleAriaLabel: 'Drag handle',
	dragHandleAriaDescription: 'Use Space or Enter to activate drag, arrow keys to move, Space or Enter to submit, or Escape to discard.',
	resizeHandleAriaLabel: 'Resize handle',
	resizeHandleAriaDescription: 'Use Space or Enter to activate resize, arrow keys to resize, Space or Enter to submit, or Escape to discard.',
};

export const boardI18nStrings: BoardProps.I18nStrings<{ title: string }> = {
	liveAnnouncementDndStarted: (operationType) => `Operation ${operationType} started`,
	liveAnnouncementDndItemReordered: (op) => `Item ${op.item.data?.title} reordered`,
	liveAnnouncementDndItemResized: (op) => `Item ${op.item.data?.title} resized`,
	liveAnnouncementDndItemInserted: (op) => `Item ${op.item.data?.title} inserted`,
	liveAnnouncementDndCommitted: (operationType) => `Operation ${operationType} committed`,
	liveAnnouncementDndDiscarded: (operationType) => `Operation ${operationType} discarded`,
	liveAnnouncementItemRemoved: (op) => `Item ${op.item.data?.title} removed`,
	navigationAriaLabel: 'Board navigation',
	navigationItemAriaLabel: (item) => item?.data?.title || 'Board item',
};

export const STATUS_COLORS: Record<string, string> = {
	DRAFT: colorChartsStatusNeutral,
	READY: colorChartsStatusInfo,
	RUNNING: colorChartsStatusMedium,
	COMPLETED: colorChartsStatusPositive,
};

export const FALLBACK_COLORS = [
	colorChartsPaletteCategorical6,
	colorChartsPaletteCategorical7,
	colorChartsPaletteCategorical8,
	colorChartsPaletteCategorical9,
];

/** Adds line breaks for long x-axis labels. 18 chars is roughly the max that fits without overlapping adjacent bars at MIN_WIDTH_PER_WORKFLOW (180px). */
const MAX_LABEL_LENGTH = 18;

export const xTickFormatter = (tickValue: string) => {
	const label = String(tickValue);
	if (label.length <= MAX_LABEL_LENGTH) return label;
	return label.match(new RegExp(`.{1,${MAX_LABEL_LENGTH}}`, 'g'))?.join('\n') ?? label;
};
export const yTickFormatter = (tickValue: number) => tickValue % 1 === 0 ? String(tickValue) : '';

/** Minimum width per workflow bar to fit the label, bar, and spacing without overlap */
export const MIN_WIDTH_PER_WORKFLOW = 180;

export const REGION_BAR_COLOR = colorChartsPaletteCategorical1;
export const COUNTRY_BAR_COLOR = colorChartsPaletteCategorical2;